import * as React from 'react';
import { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import cn from 'classnames';
import Fade from '@mui/material/Fade';
import { useTheme } from '../../theme';
import FullScreenDialogHeader from './Header/Header';
import { useBlurActiveElement } from '../../hooks';
const SlideUp = React.forwardRef((props, ref) => (React.createElement(Slide, Object.assign({ direction: "up" }, props, { ref: ref, children: props.children }))));
const FadeTransition = React.forwardRef((props, ref) => (React.createElement(Fade, Object.assign({}, props, { ref: ref, children: props.children }))));
const FullscreenDialog = React.forwardRef(({ mountOnEnter, isOpen, children, title, headerClassName, closeClassName, contentClassName, fadeTransition, keepMounted, onClose, rootDialogClassName, hideHeader, backButtonRender }, ref) => {
    const { FullscreenDialog: theme } = useTheme('FullscreenDialog');
    const [dialogIsMounted, setDialogIsMounted] = useState(!mountOnEnter);
    /**
     * WEBSKY-5566:
     * Перед закрытием модалки/диалогового окна, снимаем фокус с активного элемента (если есть),
     * чтобы избежать ошибки "blocked aria-hidden".
     */
    useBlurActiveElement(isOpen);
    useEffect(() => {
        if (isOpen && !dialogIsMounted) {
            setDialogIsMounted(true);
        }
    }, [isOpen, dialogIsMounted]);
    return (React.createElement(Dialog, { open: isOpen, TransitionComponent: !fadeTransition ? SlideUp : FadeTransition, fullScreen: true, disableEnforceFocus: true, closeAfterTransition: false, onClose: onClose, classes: {
            root: cn(theme.withoutPadding, rootDialogClassName)
        }, keepMounted: keepMounted },
        !hideHeader && (React.createElement(FullScreenDialogHeader, { onClose: onClose, title: title, headerClassName: headerClassName, closeClassName: closeClassName })),
        dialogIsMounted && (React.createElement("div", { ref: ref, className: cn(theme.content, contentClassName, {
                [theme.content_withoutOffset]: hideHeader
            }) }, children))));
});
export default FullscreenDialog;
